import {
  fetchMobilePushOperation,
  updateDraftMobilePushOperation,
} from 'admin/actions/mobile-push-operations';
import { Button } from 'admin/components/atoms/Buttons';
import BreadCrumb from 'admin/components/molecules/BreadCrumb';
import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import MessageComposeForm from '../MobilePushOperationNewForm/MessageComposeForm';

const crumb = [
  { value: 'ホーム', href: '/', isCurrentPage: false },
  { value: '販促管理', href: '', isCurrentPage: true },
  { value: 'プッシュメッセージ', href: '/promotion/mobile-push-operations', isCurrentPage: false },
  { value: '編集', href: '', isCurrentPage: true },
];

const normalizeDatetime = (value) => (value ? new Date(value).toISOString() : null);

const Header = styled.div`
  font-weight: 600;
  margin: 4px auto;
`;

const Section = styled.div`
  margin: 15px auto;
`;

const MarginButton = styled(Button)`
  margin-right: 10px;
`;

const CustomersCount = styled.div`
  margin: 20px auto 30px;
`;

const MobilePushOperationEditForm = ({
  user,
  history,
  privateMoneyId,
  operationId,
  fetchMobilePushOperation,
  updateDraftMobilePushOperation,
}) => {
  const formMethods = useForm({
    mode: 'onChange',
  });
  const { register, handleSubmit, reset, setValue } = formMethods;
  const [operation, setOperation] = useState({});
  const { id, users_count } = operation;

  useEffect(() => {
    fetchMobilePushOperation(operationId).then((response) => {
      setOperation(response);
      reset({
        subject: response.subject,
        message: response.message,
        scheduled_at: response.scheduled_at ? moment(response.scheduled_at) : undefined,
      });
    });
  }, []);

  const onSubmit = (data) => {
    updateDraftMobilePushOperation(
      operationId,
      _.pickBy(
        Object.assign({}, data, {
          scheduled_at: normalizeDatetime(data.scheduled_at),
        }),
        (v) => !_.isNull(v)
      )
    ).then((response) => {
      history.push('/promotion/mobile-push-operations');
    });
  };

  return (
    <div>
      <BreadCrumb crumbs={crumb} />

      <form onSubmit={handleSubmit(onSubmit)}>
        <Section>
          <Header>送信メッセージ</Header>
          {id && (
            <FormProvider {...formMethods}>
              <MessageComposeForm />
              <CustomersCount>お客様数: {users_count}</CustomersCount>
            </FormProvider>
          )}
        </Section>

        <div>
          <input type="hidden" {...register('status')} />
          <MarginButton onClick={() => setValue('status', 'draft')} variant="muted-outline">
            下書き保存
          </MarginButton>
          <MarginButton onClick={() => setValue('status', 'submitted')}>確定</MarginButton>
        </div>
      </form>
    </div>
  );
};

const MobilePushOperationEditFormContainer = (props) => (
  <MobilePushOperationEditForm operationId={props.match.params.id} {...props} />
);

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchMobilePushOperation, updateDraftMobilePushOperation }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MobilePushOperationEditFormContainer);
